import React from "react";
var __jsx = React.createElement;
import { cn } from "@lib/cn";
const MaxWidthContainer = _ref => {
  let {
    children,
    className,
    fullWidth
  } = _ref;
  return __jsx("div", {
    className: cn("w-full flex flex-1 justify-center", className)
  }, __jsx("div", {
    className: cn("w-full", !fullWidth && "max-width-component")
  }, children));
};
export default MaxWidthContainer;